import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["specificationSelect", "versionSelect"];

  updateVersions() {
    const specificationId = this.specificationSelectTarget.value;
    const versionSelect = this.versionSelectTarget;
    
    // Clear current versions
    versionSelect.innerHTML = '<option value="">Select a version...</option>';
    
    if (!specificationId) {
      return;
    }

    // Fetch versions for the selected specification
    fetch(`/specifications/${specificationId}/versions/options_for_select.json`)
      .then(response => response.json())
      .then(versions => {
        versions.forEach(version => {
          const option = document.createElement('option');
          option.value = version.id;
          option.textContent = version.name;
          versionSelect.appendChild(option);
        });
      })
      .catch(error => {
        console.error('Error fetching versions:', error);
      });
  }
} 